<template>
    <div>
      <EmployeeApprovedLiquidations/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import EmployeeApprovedLiquidations from '@/components/EmployeeApprovedLiquidations.vue'
  
  export default {
    name: 'liquidation-approval-history-view',
    components: {
      EmployeeApprovedLiquidations
    }
  }
  </script>
  